import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello everyone, my name is{" "}
            <span className="purple">Dang Ngoc Tien </span>
            and I come from{" "}
            <span className="purple"> Binh Thuan Province, Vietnamese.</span>
            <br /> Currently, I am a third-year student majoring in{" "}
            <span className="purple"> Software Engineering </span> 
            at VNUHCM-University of Science, Ho Chi Minh City.
            <br /> I am eager to apply the{" "}
            <span className="purple">knowledge and skills </span> I have gained
            to real-world situations, to solve problems and contribute to the
            development of the software industry
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>

            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "All success in life comes from practice!"{" "}
          </p>
          <footer className="blockquote-footer">Dang Ngoc Tien</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
